import { BannerContextProvider } from 'app/agriculture/contexts/BannerContextProvider';
import { AsideStateContextProvider } from 'app/agriculture/components/ContentBox/context/AsideStateContextProvider';

export function IndependentProviders({ children }: { children: React.ReactNode }) {
    return (
        <BannerContextProvider>
            <AsideStateContextProvider initialImageOpen={false}>
                {children}
            </AsideStateContextProvider>
        </BannerContextProvider>
    );
}
